// EngagementContext.js

import React, { createContext, useContext, useMemo, useState } from 'react';

const EngagementContext = createContext(null);

export const EngagementProvider = ({ children }) => {
  const [comments, setComments] = useState([]);
  const [commentLikes, setCommentLikes] = useState([]);
  const [commentDislikes, setCommentDislikes] = useState([]);
  const [likes, setLikes] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [shares, setShares] = useState([]);

  const value = useMemo(() => ({
    comments,
    setComments,
    commentLikes,
    setCommentLikes,
    commentDislikes,
    setCommentDislikes,
    likes,
    setLikes,
    favorites,
    setFavorites,
    shares,
    setShares,
  }), [comments, commentLikes, commentDislikes, likes, favorites, shares]);

  return (
    <EngagementContext.Provider value={value}>
      {children}
    </EngagementContext.Provider>
  );
};

export const useEngagement = () => {
  const context = useContext(EngagementContext);
  if (!context) {
    throw new Error('useEngagement must be used within EngagementProvider');
  }
  return context;
};

export default EngagementContext;
